// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ScanProxyApi } from '@digitalasset/validator-scan-proxy-api-ts-client';
import { TransferPreapproval } from '@daml.js/splice-amulet/lib/Splice/AmuletRules';
import { DisclosedContract } from '@daml/types';
import TemplateContract from './TemplateContract';

export const getTransferPreapproval = async (scanProxyApi: ScanProxyApi, feeReceiver: string) => {
  const transferPreapprovalResponse =
    await scanProxyApi.lookupTransferPreapprovalByParty(feeReceiver);
  const transferPreapproval = TemplateContract.fromScanProxyAPI(
    TransferPreapproval,
    transferPreapprovalResponse.transfer_preapproval.contract,
  );

  const disclosedPreapproval: DisclosedContract[] = [
    {
      contractId: transferPreapproval.contractId,
      templateId: transferPreapproval.templateId,
      createdEventBlob: transferPreapproval.createdEventBlob,
    },
  ];

  return { transferPreapproval, disclosedPreapproval };
};
